import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ef2fb02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal__content_title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "modal__content_close"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 32 32",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.7071 6.29289C26.0976 6.68342 26.0976 7.31658 25.7071 7.70711L7.70711 25.7071C7.31658 26.0976 6.68342 26.0976 6.29289 25.7071C5.90237 25.3166 5.90237 24.6834 6.29289 24.2929L24.2929 6.29289C24.6834 5.90237 25.3166 5.90237 25.7071 6.29289Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L25.7071 24.2929C26.0976 24.6834 26.0976 25.3166 25.7071 25.7071C25.3166 26.0976 24.6834 26.0976 24.2929 25.7071L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z",
      fill: "currentColor"
    })
  ])
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: {}
  },
  emits: ["close", "submit"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"])),
      class: "modal__content"
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _hoisted_2,
      _renderSlot(_ctx.$slots, "default")
    ], 32)
  ]))
}
}

})